import { VERTICALS } from '../data/verticals';
import VerticalPage from './VerticalPage';

const Corporate = () => <VerticalPage config={VERTICALS['corporate']} />;

export default Corporate;
